import { KdsModal, KdsText } from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";

import { useToasts } from "@/hooks";
import { useOrderItemsPreMedia } from "@/oms/hooks/queries/useOrderItemPreMedia";

import { type ModalPreMediaValidationProps } from "./ModalPreMediaBriefValidation.types";

export const ModalPreMediaBriefValidation = ({
  isOpen,
  onCloseModal,
  orderItem,
}: ModalPreMediaValidationProps) => {
  const { t } = useTranslate();
  const { add } = useToasts();
  const { useAcceptSandboxItemPreMediaRequest } = useOrderItemsPreMedia();
  const {
    mutateAsync: acceptSandboxItemPreMediaRequest,
    isPending: isAcceptingPreMediaRequest,
  } = useAcceptSandboxItemPreMediaRequest();

  const handleAddPreMediaPropositionFile = async () => {
    try {
      const res = await acceptSandboxItemPreMediaRequest({
        orderId: orderItem.orderId,
        orderItemId: orderItem.id,
      });

      if (res.status === 201 || res.status === 200 || res.status === 204) {
        add({
          state: "success",
          title: t("toast.type.success"),
        });
        onCloseModal();
      } else {
        add({
          state: "error",
          title: t("toast.generic.error"),
        });
      }
    } catch {
      add({
        state: "error",
        title: t("toast.generic.error"),
      });
    }
  };

  return (
    <KdsModal
      isOpen={isOpen}
      callbackOnClose={onCloseModal}
      size="sm"
      dialogProps={{
        dialogHeaderProps: {
          title: t("order.myOrdersItemDetails.preMedia.shareWithClient"),
        },
        content: (
          <KdsText>
            {t("order.myOrdersItemDetails.preMedia.shareWithClientDescription")}
          </KdsText>
        ),
        dialogFooterProps: {
          buttonProps: [
            {
              variant: "outlined",
              color: "neutral",
              children: t("buttons.cancel"),
              onPress: onCloseModal,
            },
            {
              children: t("order.myOrdersItemDetails.preMedia.validate"),
              isLoading: isAcceptingPreMediaRequest,
              disabled: isAcceptingPreMediaRequest,
              type: "submit",
              dataCy: "submitPreMediaPropositionFileButton",
              onPress: () => {
                void handleAddPreMediaPropositionFile();
              },
            },
          ],
        },
      }}
    />
  );
};
